import registrationInstance from '../instance'

const deleteUser = (id) => {
	return registrationInstance.delete('/users/' + id)
}

export default deleteUser
